import { Box, Button, GridProps, Stack, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import Heading from './Heading';
import { IntegrationBlockProps as Props } from '../types';
import { useTranslation } from '../lib/hooks.context';
import { useCookieConsent } from '../lib/hooks';

const IntegrationBlock = ({
  title,
  bot_id,
  type,
  ...styles
}: Props & GridProps) => {
  const { consent, renewConsent } = useCookieConsent();
  const { locale } = useRouter();
  const t = useTranslation();

  // don't allow anything else than numbers and letters in bot_id
  /* eslint-disable-next-line no-useless-escape */
  if (!bot_id || !/^[\w.\-\/]+$/.test(bot_id)) {
    return null;
  }

  return (
    <Box data-test-id="section-integration-block" as="section">
      {title && (
        <Heading textAlign="center" variant="h4" as="h2">
          {title}
        </Heading>
      )}
      {consent?.preferences && type === 'bot_slot' ? (
        <Box
          key={`botblock_${locale || 'fi'}`}
          data-code={bot_id}
          className="ld-slot"
          data-name={bot_id}
        />
      ) : (
        <Stack
          shouldWrapChildren
          mt={8}
          mx="auto"
          py={8}
          px={[8, 8, 8, '8.33333333%']}
          textAlign="center"
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray3"
          maxW="container.md"
        >
          <Text mb="4">{t('bot_no_cookies')}</Text>

          <Button
            size="sm"
            colorScheme="primary"
            variant="solidGreen"
            onClick={renewConsent}
          >
            {t('change_cookie_preferences')}
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default IntegrationBlock;
